import moment from 'moment';

export default {
    formatDate: (timestamp, format) => {
        ////let year = timestamp.getYear();                       //獲取當前年份(2位)
        //let fullYear = timestamp.getFullYear();                 //獲取完整的年份(4位,1970-????)
        //let month = timestamp.getMonth();                       //獲取當前月份(0-11,0代表1月)
        //let date = timestamp.getDate();                         //獲取當前日(1-31)
        ////let day = timestamp.getDay();                         //獲取當前星期X(0-6,0代表星期天)
        ////let time = timestamp.getTime();                       //獲取當前時間(從1970.1.1開始的毫秒數)
        //let hour = timestamp.getHours();                        //獲取當前小時數(0-23)
        //let minutes = timestamp.getMinutes();                   //獲取當前分鐘數(0-59)
        //let seconds = timestamp.getSeconds();                   //獲取當前秒數(0-59)
        //let milliseconds = timestamp.getMilliseconds();         //獲取當前毫秒數(0-999)
        ////let localdate = timestamp.toLocaleDateString();       //獲取當前日期
        ////let mytime = timestamp.toLocaleTimeString();          //獲取當前時間
        ////let local = timestamp.toLocaleString();               //獲取日期與時間----如果涉及到時分秒, 直接使用即可

        //return fullYear + "-" +
        //    ("0" + (month + 1)).slice(-2) 
        //    + "-" + ("0" + date).slice(-2) 
        //    + " " + ("0" + hour).slice(-2) 
        //    + ":" + ("0" + minutes).slice(-2) 
        //    + ":" + ("0" + seconds).slice(-2) 
        //    //+ "." + ("0" + milliseconds).slice(-3)
        //    ;
        return moment(timestamp).format(format);
    },
    getUuidv4: () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    getRoomId: (type, id) => {
        return type.toString() + "_" + id;
    },
    getServerRoomType: (roomId) => {
        return parseInt(roomId.split('_')[0]);
    },
    getPreviewImageUrl: (sourceUrl) => {
        let index = sourceUrl.lastIndexOf(".");
        if (index >= 0) {
            return sourceUrl.slice(0, index) + "d" + sourceUrl.slice(index);
        } else {
            return sourceUrl + "d";
        }
    },
    scrollbarTop: (scrollbar) => {
        if (scrollbar) {
            scrollbar.scrollTop = 0;
        }
    },
    scrollbarBottom: (scrollbar) => {
        if (scrollbar) {
            scrollbar.scrollTop = scrollbar.scrollHeight;
        }
    },
    registerDragElement: (target, handle) => {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        let targetHeight = target.offsetHeight;
        let targetWidth = target.offsetWidth;

        handle.onmousedown = dragMouseDown;

        function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
        }

        function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();

            let topLimit = document.body.offsetHeight - targetHeight;
            let leftLimit = document.body.offsetWidth - targetWidth;

            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            // set the element's new position:
            let newTop = (target.offsetTop - pos2);
            if (newTop > topLimit) {
                newTop = topLimit;
            } else if (newTop < 0) {
                newTop = 0;
            }

            let newLeft = (target.offsetLeft - pos1);
            if (newLeft > leftLimit) {
                newLeft = leftLimit;
            } else if (newLeft < 0) {
                newLeft = 0;
            }

            target.style.top = newTop + "px";
            target.style.left = newLeft + "px";
        }

        function closeDragElement() {
            // stop moving when mouse button is released:
            document.onmouseup = null;
            document.onmousemove = null;
        }
    },
    linkify: (inputText) => {
        let replacedText, replacePattern1, replacePattern2, replacePattern3;
        //URLs starting with http://, https://, or ftp://
        replacePattern1 = /((https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
        replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    
        //URLs starting with "www." (without // and @ before it, or without @ after it, or it'd re-link the ones done above).
        replacePattern2 = /(^|[^/@])((?!\S*@\S*)(www\.[\S]+(\b|$)))/gim;
        replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    
        //Change email addresses to mailto:: links.
        replacePattern3 = /([\w.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
        replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
        return replacedText;
    }
}